import { render, staticRenderFns } from "./CollectDetailInfoLayout.vue?vue&type=template&id=74f6bc46&scoped=true"
import script from "./CollectDetailInfoLayout.vue?vue&type=script&lang=js"
export * from "./CollectDetailInfoLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f6bc46",
  null
  
)

export default component.exports